module.exports = __webpack_public_path__ + "img/big-main.8a89ee33.webp";